import React, { useEffect, useState } from "react";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import { LOCATION } from "../../utils/Utils";

const MyDriverBonus = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [waitingData, setWaitingData] = useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [summary, setSummary] = useState({});
  const [summaryWaiting, setSummaryWaiting] = useState({});
  const [filter, setFilter] = useState({
    monthYear: searchParams.get("monthYear") || moment().format("YYYY-MM"),
  });

  const colTable = [
    {
      Header: "Ngày",
      accessor: (item) => moment(item.createdAt).format('DD-MM-YYYY'),
    },
    {
      Header: "Mã",
      accessor: (item) => item.id,
    },

    {
      Header: "Điểm A",
      accessor: (item) => item?.fromLocationName,
    },
    {
      Header: "Điểm B",
      accessor: (item) => item?.toLocationName,
    },
    {
      Header: "Địa điểm",
      accessor: (item) => item.location ? LOCATION[item.location] : ''
    },
    {
      Header: "Biển số xe",
      accessor: (item) => item.truckId,
    },
    {
      Header: "Số lượng(kg)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.finalMerchandiseWeight || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Tài chính(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.driverBonus || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
    {
      Header: "Tài phụ(đ)",
      className: 'text-right',
      accessor: (item) => (
        <NumericFormat
          displayType={"text"}
          value={item.subDriverBonus || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
      ),
    },
  ];

  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...(filter.monthYear ? { monthYear: filter.monthYear } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    setLoading(true);
    setData([]);
    let params = {
      ...(filter.monthYear ? { monthYear: filter.monthYear } : {}),

    };

    GET(`self-employee/driver-bonus`, params, true)
      .then(({ data }) => {
        setData([...data.rows]);
        setWaitingData([...data.waitingTransports]);
        setSummary({
          ...data.summary,
        })
        setSummaryWaiting({
          ...data.summaryWaiting,
        })
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter]);

  return (
    <React.Fragment>
      <Head title="Thưởng chuyến xe của tôi"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Thưởng chuyến xe của tôi</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <h5 className="text-center">Thưởng chuyến đã duyệt</h5>

              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    headerRow={<>
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td colSpan={6} rowSpan={2} className="nk-tb-col">
                          <span>Tổng cộng: </span>({summary.transportByBillCount} chuyến nội bộ, {summary.transportByContractCount} chuyến chạy thuê)
                        </td>
                        <td></td>
                        <td colSpan={2} className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary.total || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","

                            decimalScale={2}
                          />
                        </td>
                      </tr>
                      <tr className="nk-tb-item odd font-weight-bold">

                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary.finalMerchandiseWeight || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","

                            decimalScale={2}
                          />
                        </td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary.driverBonus || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","

                            decimalScale={2}
                          />
                        </td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summary.subDriverBonus || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","

                            decimalScale={2}
                          />
                        </td>
                      </tr>
                    </>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <h5 className="text-center">Thưởng chuyến đang chờ duyệt</h5>

              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={waitingData}
                    notShowPagi={true}
                    headerRow={<>
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td colSpan={6} rowSpan={2} className="nk-tb-col">
                          <span>Tổng cộng: </span>({summaryWaiting.transportByBillCount} chuyến nội bộ, {summaryWaiting.transportByContractCount} chuyến chạy thuê)
                        </td>
                        <td></td>
                        <td colSpan={2} className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryWaiting.total || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","

                            decimalScale={2}
                          />
                        </td>
                      </tr>
                      <tr className="nk-tb-item odd font-weight-bold">

                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryWaiting.finalMerchandiseWeight || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","

                            decimalScale={2}
                          />
                        </td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryWaiting.driverBonus || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","

                            decimalScale={2}
                          />
                        </td>
                        <td className="text-right">
                          <NumericFormat
                            displayType={"text"}
                            value={summaryWaiting.subDriverBonus || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","

                            decimalScale={2}
                          />
                        </td>
                      </tr>
                    </>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default MyDriverBonus;
